var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"align-middle d-print-none align-items-baseline"},[_c('router-link',{staticClass:"wallet-plain-link",attrs:{"to":{name:'UserWallets',params:{user:_vm.$store.getters['User/getProfile'].id}}}},[_vm._v(" مدیریت کیف پول ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }